import { useFormik } from "formik";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import * as yup from "yup";
import useAddFormData from "../../../../Components/Hooks/useAddFormData";
import { useEffect, useState } from "react";
import Input, { NuDate, NuInput, NuSelect, NuTextArea } from "../../../../Components/Utils/Input";
import UseEditData from "../../../../Components/Hooks/useEditData";
import { Link, useLocation } from "react-router-dom";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import axiosInstance from "../../../../Services/axiosCommon";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";

const EditReceivables = () => {
  // const {value:Category} = useFetchMataData(`/dropdown/dropdown-details/`,'Category_Recevable')
  const { value: status, getData: refstatus } = useFetchMataData(`/dropdown/dropdown-details/`, 'Status_Recevable')
  const { value: AccountType } = useFetchMataData(`/dropdown/dropdown-details/`, 'AccountType__Recevable')
  // const [loading, setLoading] = useState(false);

  const { Oncancel, editData, contextHolder, isLoading } = UseEditData();
  const location = useLocation();
  const data = location.state.data;
  const from = location.state.from;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;

  const [createNew, setCreateNew] = useState({
    description: data?.description || "",
    amount: data?.amount || "",
    category: data?.category || "",
    accountType: data?.accountType || "",
    receiveFrom: data?.receiveFrom || "",
    // daysElapsed: data?.daysElapsed || "",
    dueDate: data?.dueDate || "",
    // receivedAmount: data?.receivedAmount || "",
    // balanceAmount: data?.balanceAmount || "",
    // paymentMethod: data?.paymentMethod || "",
    // receivedOn: data?.receivedOn || "",
    // comments: data?.comments || "",
    invoiceId: data?.invoiceId || "",
    status: data?.status || ""
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      // setLoading(true); 
      editData(`/receivable/edit-receivable/${data?.receivableId}`, value, resetForm, from, { currentPage: pageIndex, searchQuery: searchQuery })
      // setLoading(false)

    },
  });
  const { data: invoiceOutgoing } = UseDropDown('/invoices-outgoing/drop-down');
  const { data: customer } = UseDropDown('/customers/drop-down');
  return (
    <div className="w-full h-full py-2 px-4">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 mb-2">

        <Breadcrumb
          items={
            [
              {
                name: "Payment",
                link: "/payments/receivables"
              },
              {
                name: "Receivables",
                link: "/payments/receivables"
              },
              {
                name: "Edit Receivables"
              }]
          }
        />
        <Link
          to={from || "/payments/receivables"}
          state={{
            currentPage: pageIndex,
            searchQuery: searchQuery || "",
          }}
        >
          <BackButton link={true} />
        </Link>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto min-h-[calc(100vh-145px)] h-auto md:h-[calc(100vh-145px)] bg-white rounded-md overflow-hidden mt-4">
          <div className="w-full h-full py-2 px-2 flex justify-start content-start flex-wrap overflow-y-auto">
            <FormikSelectTwo
              label="Invoice"
              placeholder="Choose"
              Options={invoiceOutgoing}
              formik={formik}
              disabled={true}
              name="invoiceId"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            <NuInput
              type="number"
              label="Amount"
              placeholder="amount"
              formik={formik}
              name="amount"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            {/* <FormikSelectTwo
              label="Category"
              placeholder="Choose"
              Options={Category}
              formik={formik}
              name="category"
              width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            <FormikSelectTwo
              label="Account Type"
              placeholder="Choose"
              Options={AccountType}
              formik={formik}
              name="accountType"
              width="w-full md:w-1/2 lg:w-1/3"
            />

            <FormikSelectTwo
              label="Received From"
              placeholder="Choose"
              Options={customer}
              formik={formik}
              name="receiveFrom"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            {/* <NuInput
              type="number"
              label="Days Elapsed"
              placeholder="daysElapsed"
              formik={formik}
              name="daysElapsed"
               width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            <NuDate
              label="Due Date"
              placeholder="dd/mm/yyyy"
              formik={formik}
              name="dueDate"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            {/* <NuInput
              type="number"
              label="Received Amount"
              placeholder="receivedAmount"
              formik={formik}
              name="receivedAmount"
              width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            {/* <NuInput
              type="number"
              label="Balance Amount"
              placeholder="Balance Amount"
              formik={formik}
              name="balanceAmount"
               width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            <NuInput
              type="text"
              label="Description"
              placeholder="Description"
              formik={formik}
              name="description"
              width="w-full md:w-1/2 lg:w-1/3"
            />
            {/* <FormikSelectTwo
              label="Payment Method"
              placeholder="Choose"
              Options={[
                {value:"online",label:"online"},
                {value:"offline",label:"offline"},
              ]}
              formik={formik}
              name="paymentMethod"
             width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            {/* <NuDate
              label="Received On"
              placeholder="dd/mm/yyyy"
              formik={formik}
              name="receivedOn"
              width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            {/* <DropDownAddMetaData
                label="Status"
                placeholder="Choose"
                Options={status}
                formik={formik}
                name="status"
                width="w-full md:w-1/2 lg:w-1/3"
                getFunc={refstatus}
                displayProperty={"Status"}
                propertyName={"Status_Recevable"}
              /> */}
            {/* <FormikSelectTwo
              label="Status"
              placeholder="Choose"
              Options={status}
              formik={formik}
              name="status"
              width="w-full md:w-1/2 lg:w-1/3"
            /> */}
            {/* <NuTextArea
              label="Comments"
              placeholder="comments"
              formik={formik}
              name="comments"
                width="w-full md:w-1/2 lg:w-1/3"
            />             */}
            <div className="w-full mx-auto my-4 mt-8 px-2">
              <div className="flex justify-end gap-3 sm:gap-4">
                <CancelButton handleClick={() => { Oncancel(from, { currentPage: pageIndex, searchQuery: searchQuery }) }} />
                <SubmitButton isLoading={isLoading} />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default EditReceivables;
